import { v4 as uuidv4 } from 'uuid';
import compressImage from "./compressImage.js";


// Handle file upload and compression
const handleImageUpload = async (event, { setThumbnails, thumbnails, setImages }) => {

  const files = Array.from(event.target.files);

  console.log(files);

  const renamedFiles = files.map((file) => {
    const uuidName = uuidv4() + '.' + file.name.split('.').pop(); // zachováš príponu
    const renamedFile = new File([file], uuidName, { type: file.type });
    renamedFile.id = uuidv4(); // voliteľné, ak chceš id navyše
    return renamedFile;
  });

  console.log(renamedFiles);

  setImages((prev) => [...prev, ...renamedFiles]);

  const compressedFiles = await Promise.all(files.map((file) => compressImage(file)));
  const newThumbnails = compressedFiles.map((compressedFile, index) => {
    return {fileURL: compressedFile, id: thumbnails.length + index}
  });

  console.log(newThumbnails);


  setThumbnails((prev) => [...prev, ...newThumbnails]);
};

export default handleImageUpload;